import type { Rol } from '@/types/api';

// Etiqueta visible de cada rol (lenguaje neutro, decisión de Juan del 24/9/2026:
// BACKLOG «Lenguaje neutro en toda la app», caso C). Los códigos (`viewer`,
// `gestor`, `admin`) no cambian: son los identificadores del backend y de la
// base. Vive en un `.ts` sin componentes para que lo compartan el menú de
// usuario, Administración y Auditoría sin pisar `react-refresh/only-export-components`.
export const ROL_LABEL: Record<Rol, string> = {
  viewer: 'Consulta',
  gestor: 'Gestión',
  admin: 'Administración',
};

/** Etiqueta de un rol que llega como string suelto (el value de un `Select`,
 *  una fila de Auditoría). Si no es uno de los tres códigos conocidos se
 *  muestra tal cual; `hasOwn` evita que un string como `toString` devuelva
 *  algo del prototipo. */
export function rolLabel(rol: string): string {
  return Object.hasOwn(ROL_LABEL, rol) ? ROL_LABEL[rol as Rol] : rol;
}
